// ==== GOOGLE TRANSLATE WIDGET — TEMPORARY, DELETE IF DROPPED ====
// On mount: moves the body-level #google_translate_wrap node into this slot
// in the navbar, so the widget appears next to the EN/DE flags.
// On unmount: moves it back to <body> (preserved — not destroyed — so the
// live Google-Translate state survives any React route/layout change).
// Because the widget is a plain DOM subtree that React never renders into,
// no re-render can wipe its contents. Google's init script lives in
// ui/index.html and runs independently.

import { useEffect, useRef } from 'react';

export default function GoogleTranslateSlot() {
  const slotRef = useRef<HTMLSpanElement | null>(null);

  useEffect(() => {
    const host = document.getElementById('google_translate_wrap');
    const slot = slotRef.current;
    if (!host || !slot) return;
    host.style.display = '';
    slot.appendChild(host);
    return () => {
      if (host.parentElement === slot) {
        host.style.display = 'none';
        document.body.appendChild(host);
      }
    };
  }, []);

  return (
    <span
      ref={slotRef}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        verticalAlign: 'middle',
        marginRight: 8,
      }}
    />
  );
}
// ==== END GOOGLE TRANSLATE WIDGET ====
